// frontend/src/pages/PaymentSuccess.jsx
import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

export default function PaymentSuccess() {
  const { user, token, updateUser } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [credits, setCredits] = useState(user?.credits || 0);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const verifyPayment = async () => {
      try {
        const params = new URLSearchParams(location.search);
        const reference = params.get("reference");

        if (!reference) {
          setError("No payment reference found.");
          setLoading(false);
          return;
        }

        if (!token) {
          setError("You must be logged in to verify payment.");
          setLoading(false);
          return;
        }

        // Call backend to verify payment
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL || "https://globisun-app.onrender.com"}/api/paystack/verify-payment?reference=${reference}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (res.data?.success) {
          const newCredits = res.data.credits ?? user.credits;
          setCredits(newCredits);

          // Update user in context
          const updatedUser = { ...user, credits: newCredits };
          updateUser(updatedUser);

          // Redirect to chat after 2s
          setTimeout(() => {
            navigate("/ai-assistant");
          }, 2000);
        } else {
          setError(res.data.error || "Payment verification failed.");
        }
      } catch (err) {
        console.error("Payment verification error:", err);
        setError("An error occurred while verifying your payment.");
      } finally {
        setLoading(false);
      }
    };

    verifyPayment();
  }, [location.search, token, user, updateUser, navigate]);

  if (loading) return <p>Verifying your payment...</p>;

  if (error)
    return (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <h2>Payment Verification Failed ❌</h2>
        <p style={{ color: "red" }}>{error}</p>
        <button
          onClick={() => navigate("/ai-assistant")}
          style={{ marginTop: "20px", padding: "10px 20px", cursor: "pointer" }}
        >
          Go Back
        </button>
      </div>
    );

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h1>Payment Successful ✅</h1>
      <p>
        Your new credit balance is: <strong>{credits}</strong>
      </p>
      <p>Redirecting you to the chat...</p>
    </div>
  );
}
